import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SpcenterdataService {
  private baseUrl = environment.apiBaseUrl;
  constructor(private dataService: DataService, private http: HttpClient) { }

  getDeviceList(serialNumber) {

    return this.dataService.getRecord('/api/spcenter/getDeviceList/' + serialNumber);
  }

  //getAllDeviceList  () {
  //    
  //    return this.dataService.getLookupData('/api/spcenter/getAllDeviceList');
  //}

  getDeviceOnLoad() {

    return this.dataService.getRecord('/api/spcenter/getDeviceOnLoad/');
  }

  getDeviceSearch(searchQuery) {

    return this.dataService.getRecordWithParams('/api/spcenter/getDeviceSearch/', searchQuery);
  }

  //getCounterList  () {
  //    
  //    return this.dataService.getLookupData('/api/spcenter/getCounterList');
  //}
  //getCounterListPerDay  () {
  //    
  //    return this.dataService.getLookupData('/api/spcenter/getCounterListPerDay');
  //}

  getMonthUsageByCustomer = function (params) {
    return this.dataService.getRecordWithParams('/api/spcenter/getMonthUsageByCustomer', params);
  }

  getYearUsageByCustomer(params) {
    return this.dataService.getRecordWithParams('/api/spcenter/getYearUsageByCustomer', params);
  }

  getTopUpUsageByCustomer(params) {
    return this.dataService.getRecordWithParams('/api/spcenter/getTopUpUsageByCustomer', params);
  }

  viewChartApplication(params) {
    return this.dataService.getRecordWithParams('/api/spcenter/viewChartApplication', params);
  }

  saveInventoryDevice(params) {
    return this.dataService.post('/api/spcenter/saveInventoryDevice', params);
  }

  saveBulkInventoryDevice(data) {
    return this.dataService.post('/api/spcenter/saveBulkInventoryDevice', data);

  }

  GetIPPoolLists() {
    return this.dataService.getRecord('/api/spcenter/GetIPPoolLists');

  }
  GetFreeIPList(params) {
    return this.dataService.getRecord('/api/spcenter/GetFreeIPList/' + params);
  }
  SetIPUser(params) {
    return this.dataService.post('/api/spcenter/SetIPUser/', params);
  }

  ReleaseIPUser(params: string) {
  return this.http.post(this.baseUrl+'/api/spcenter/releaseIPUser', JSON.stringify(params), {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  });
}
  //getVumatelOrderDetails  (ssnNumber) {
  //    return this.dataService.getRecordWithParams('/api/VumatelOrderDetail/getVumatelOrderDetails');
  //}
}
